<h2>Users ({{ userPagination.total }})</h2>
<button nz-button nzType="primary" (click)="openCreateUserModal()">
  Create User
</button>
<div style="margin-bottom: 16px; margin-top: 16px; display: flex; gap: 8px;">
  <!-- Search Inputs -->
  <input
    nz-input
    placeholder="Search Email"
    [(ngModel)]="searchTerms.email"
    (ngModelChange)="onSearchDebounced()"
    style="width: 200px;"
  />
<!--  <input-->
<!--    nz-input-->
<!--    placeholder="Search Display Name"-->
<!--    [(ngModel)]="searchTerms.displayName"-->
<!--    (ngModelChange)="onSearchDebounced()"-->
<!--    style="width: 200px;"-->
<!--  />-->
  <input
    nz-input
    placeholder="Search Company"
    [(ngModel)]="searchTerms.companyName"
    (ngModelChange)="onSearchDebounced()"
    style="width: 200px;"
  />
  <input
    nz-input
    placeholder="Search Customer No"
    [(ngModel)]="searchTerms.customerNumber"
    (ngModelChange)="onSearchDebounced()"
    style="width: 200px;"
  />
  <input
    nz-input
    placeholder="Search Contract No"
    [(ngModel)]="searchTerms.contractNumber"
    (ngModelChange)="onSearchDebounced()"
    style="width: 200px;"
  />
</div>
<!-- User Management Table -->
<nz-table
  [nzData]="users"
  [nzSize]="'middle'"
  [nzLoading]="loading"
  [nzScroll]="{ x: '1000px' }"
  [nzShowPagination]="false"
>
  <thead>
  <tr>
    <th
      nzWidth="20%"
      nzColumnKey="email"
      [nzSortOrder]="userSort.key === 'email' ? userSort.value : null"
      (nzSortOrderChange)="onUserSortChange('email', $event)"
    >
      Email
    </th>
<!--    <th-->
<!--      nzWidth="20%"-->
<!--      nzColumnKey="displayName"-->
<!--      [nzSortOrder]="userSort.key === 'displayName' ? userSort.value : null"-->
<!--      (nzSortOrderChange)="onUserSortChange('displayName', $event)"-->
<!--    >-->
<!--      Display Name-->
<!--    </th>-->
    <th
      nzWidth="20%"
      nzColumnKey="companyName"
      [nzSortOrder]="userSort.key === 'companyName' ? userSort.value : null"
      (nzSortOrderChange)="onUserSortChange('companyName', $event)"
    >
      Company
    </th>
    <th nzWidth="12%">
      {{ 'TEAM_ACCESS.ROLE' | translate }}
    </th>
    <th
      nzWidth="15%"
      nzColumnKey="customerNumber"
      [nzSortOrder]="userSort.key === 'customerNumber' ? userSort.value : null"
      (nzSortOrderChange)="onUserSortChange('customerNumber', $event)"
    >
      Customer No.
    </th>

    <th
      nzWidth="20%"
      nzColumnKey="contractNumber"
      [nzSortOrder]="userSort.key === 'contractNumber' ? userSort.value : null"
      (nzSortOrderChange)="onUserSortChange('contractNumber', $event)"
    >
      Contract No.
    </th>
    <th
      nzWidth="12%"
      nzColumnKey="plan"
      [nzSortOrder]="userSort.key === 'plan' ? userSort.value : null"
      (nzSortOrderChange)="onUserSortChange('plan', $event)"
    >
      Plan
    </th>
    <th nzWidth="12%">Contract Start</th>
    <th nzWidth="12%">Contract End</th>
<!--    <th-->
<!--      nzWidth="15%"-->
<!--      nzColumnKey="appMode"-->
<!--      [nzSortOrder]="userSort.key === 'appMode' ? userSort.value : null"-->
<!--      (nzSortOrderChange)="onUserSortChange('appMode', $event)"-->
<!--    >-->
<!--      App Mode-->
<!--    </th>-->
    <th nzWidth="20%">Max Properties</th>
    <th nzWidth="20%">Company Status</th>
    <th nzWidth="20%">User Status</th>
    <th
      nzWidth="20%"
      nzColumnKey="createdAt"
      [nzSortOrder]="userSort.key === 'createdAt' ? userSort.value : null"
      (nzSortOrderChange)="onUserSortChange('createdAt', $event)"
    >
      Created At
    </th>
    <th
      nzWidth="20%"
      nzColumnKey="lastLogin"
      [nzSortOrder]="userSort.key === 'lastLogin' ? userSort.value : null"
      (nzSortOrderChange)="onUserSortChange('lastLogin', $event)"
    >
      Last Login
    </th>
    <th nzWidth="20%">Actions</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let user of users">
    <td>{{ user.email }}</td>
<!--    <td>{{ user.displayName }}</td>-->
    <td>{{ user.companyId?.name }}</td>
    <td>
      <ng-container *ngIf="getCompanyRoleTranslationKey(user) as companyRoleKey; else noCompanyRole">
        {{ companyRoleKey | translate }}
      </ng-container>
      <ng-template #noCompanyRole>—</ng-template>
    </td>
    <td>
      <ng-container *ngIf="user.isTestAccount; else custNo">
        <nz-tag nzColor="red">TEST</nz-tag>
      </ng-container>
      <ng-template #custNo>{{ user.customerNumber || '—' }}</ng-template>
    </td>

    <td>
      <ng-container *ngIf="user.isTestAccount; else contractNo">
        —
      </ng-container>
      <ng-template #contractNo>{{ user.contractNumber || '—' }}</ng-template>
    </td>
    <td>
      <ng-container *ngIf="user.role === 'Admin'; else showPlan">
        —
      </ng-container>
      <ng-template #showPlan>
        {{ getPlanLabel(user.plan) }}
      </ng-template>
    </td>
    <td>{{ user.contractStartDate ? (user.contractStartDate | date:'yyyy-MM-dd') : '—' }}</td>
    <td>{{ user.contractEndDate ? (user.contractEndDate | date:'yyyy-MM-dd') : '—' }}</td>
    <!--    <td>-->
<!--      {{ user.companyId?.appMode === 'hospitality' ? 'Hospitality' : 'Emergency' }}-->
<!--    </td>-->
    <td>{{ user.companyId?.maxProperties }}</td>
    <td *ngIf="user.role !== 'Admin'">
      <nz-switch
        [ngModel]="user.companyId?.isActive"
        (ngModelChange)="updateCompanyStatus(user.companyId._id, $event)"
        [nzCheckedChildren]="'Active'"
        [nzUnCheckedChildren]="'Inactive'">
      </nz-switch>
    </td>
    <td *ngIf="user.role !== 'Admin'">
      <nz-switch
        [ngModel]="!user.isDeactivated"
        (ngModelChange)="updateUserStatus(user, $event)"
        [nzCheckedChildren]="'Enabled'"
        [nzUnCheckedChildren]="'Disabled'">
      </nz-switch>

      <div style="font-size: 12px; color: #8c8c8c; margin-top: 4px;" *ngIf="user.isDeactivated">
        <ng-container *ngIf="user.deletionScheduledFor; else manualDisabled">
          Deletion scheduled: {{ user.deletionScheduledFor | date:'mediumDate' }}
        </ng-container>
        <ng-template #manualDisabled>
          Disabled (manual)
        </ng-template>
      </div>
    </td>
    <td *ngIf="user.role === 'Admin'"></td>
    <td *ngIf="user.role === 'Admin'"></td>
    <td>{{ user.companyId?.createdAt | date: 'medium' }}</td>
    <td>
      {{ user.lastLogin ? (user.lastLogin | date: 'medium') : '—' }}
    </td>
    <td>
      <button
        nz-button
        nzType="text"
        nz-tooltip
        [nzTooltipTitle]="'COMMON.EDIT' | translate"
        [attr.aria-label]="'COMMON.EDIT' | translate"
        (click)="editUser(user)"
      >
        <span nz-icon nzType="edit"></span>
      </button>
      <button
        nz-button
        nzType="text"
        nz-tooltip
        [nzTooltipTitle]="'USER_MANAGEMENT.DELETE_ACTION' | translate"
        [attr.aria-label]="'USER_MANAGEMENT.DELETE_ACTION' | translate"
        nz-popconfirm
        [nzPopconfirmTitle]="'USER_MANAGEMENT.DELETE_CONFIRMATION' | translate:{ email: user.email }"
        [nzOkText]="'USER_MANAGEMENT.DELETE_CONFIRM_OK' | translate"
        [nzCancelText]="'USER_MANAGEMENT.DELETE_CONFIRM_CANCEL' | translate"
        (nzOnConfirm)="deleteUser(user)"
        [disabled]="user.role === 'Admin'"
      >
        <span nz-icon nzType="delete"></span>
      </button>
    </td>
  </tr>
  </tbody>
</nz-table>

<nz-pagination
  [nzPageIndex]="userPagination.pageIndex"
  [nzPageSize]="userPagination.pageSize"
  [nzTotal]="userPagination.total"
  [nzPageSizeOptions]="[5, 10, 20, 50]"
  [nzShowQuickJumper]="true"
  [nzShowSizeChanger]="true"
  (nzPageIndexChange)="onUserPageIndexChange($event)"
  (nzPageSizeChange)="onUserPageSizeChange($event)"
  style="margin-top: 16px; text-align: right;"
></nz-pagination>
<!-- Create User Modal -->
<nz-modal [(nzVisible)]="isCreateUserModalVisible" nzTitle="Create User" (nzOnCancel)="closeCreateUserModal()" [nzFooter]="null" nzMaskClosable="false">
  <ng-container *nzModalContent>
    <form [formGroup]="createUserForm">
      <nz-form-item>
        <nz-form-label nzFor="email" nzRequired>Email</nz-form-label>
        <nz-form-control [nzErrorTip]="'Please enter a valid email'">
          <input nz-input formControlName="email" id="email" placeholder="Enter user email" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="companyName" nzRequired>Company Name</nz-form-label>
        <nz-form-control [nzErrorTip]="'Company name is required'">
          <input nz-input formControlName="companyName" id="companyName" placeholder="Enter company name" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control>
          <label nz-checkbox formControlName="isTestAccount">Test account</label>
        </nz-form-control>
      </nz-form-item>

      <ng-container *ngIf="!createUserForm.get('isTestAccount')?.value">
        <nz-form-item>
          <nz-form-label nzFor="customerNumber">Customer No (optional)</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="customerNumber" id="customerNumber" placeholder="e.g. K00103" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzFor="contractNumber">Contract No (optional)</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="contractNumber" id="contractNumber" placeholder="e.g. V-K00103-SC-01" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="contractStartDate">Contract Start Date</nz-form-label>
          <nz-form-control>
            <nz-date-picker
              formControlName="contractStartDate"
              id="contractStartDate"
              nzFormat="yyyy-MM-dd"
            ></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </ng-container>
      <nz-form-item>
        <nz-form-label nzFor="maxProperties" nzRequired>Max Properties</nz-form-label>
        <nz-form-control [nzErrorTip]="'Max properties is required'">
          <input nz-input formControlName="maxProperties" placeholder="Enter max properties" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="appMode" nzRequired>App Mode</nz-form-label>
        <nz-form-control [nzErrorTip]="'App mode is required'">
          <nz-select
            formControlName="appMode"
            id="appMode"
            placeholder="Select app mode"
          >
            <nz-option nzValue="emergency" nzLabel="Emergency"></nz-option>
            <nz-option nzValue="hospitality" nzLabel="Hospitality"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="plan" nzRequired>Plan</nz-form-label>
        <nz-form-control [nzErrorTip]="'Plan is required'">
          <nz-select formControlName="plan" id="plan" placeholder="Select plan">
            <nz-option nzValue="free" nzLabel="Free"></nz-option>
            <nz-option nzValue="pro" nzLabel="Pro"></nz-option>
            <nz-option nzValue="business" nzLabel="Business"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </form>

    <!-- Generated Password Display -->
    <div *ngIf="generatedPassword" class="password-container">
      <strong>Generated Password:</strong> {{ generatedPassword }}
    </div>

    <div class="modal-actions">
      <button nz-button nzType="primary" (click)="createUser()">Create</button>
      <button nz-button nzType="default" (click)="closeCreateUserModal()">Cancel</button>
    </div>
  </ng-container>
</nz-modal>


<!-- Edit User Modal -->
<nz-modal [(nzVisible)]="isEditUserModalVisible" nzTitle="Edit User Company" (nzOnCancel)="closeEditUserModal()" [nzFooter]="null" nzMaskClosable="false">
  <ng-container *nzModalContent>
    <form [formGroup]="editUserForm">
      <nz-form-item>
        <nz-form-label nzFor="maxProperties" nzRequired>Max Properties</nz-form-label>
        <nz-form-control [nzErrorTip]="'Max properties is required'">
          <input nz-input formControlName="maxProperties" placeholder="Enter max properties" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="editPlan" nzRequired>Plan</nz-form-label>
        <nz-form-control [nzErrorTip]="'Plan is required'">
          <nz-select formControlName="plan" id="editPlan" placeholder="Select plan">
            <nz-option nzValue="free" nzLabel="Free"></nz-option>
            <nz-option nzValue="pro" nzLabel="Pro"></nz-option>
            <nz-option nzValue="business" nzLabel="Business"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control>
          <label nz-checkbox formControlName="isTestAccount">Test account</label>
        </nz-form-control>
      </nz-form-item>

      <ng-container *ngIf="!editUserForm.get('isTestAccount')?.value">
        <nz-form-item>
          <nz-form-label nzFor="editCustomerNumber">Customer No</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="customerNumber" id="editCustomerNumber" placeholder="e.g. K00103" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzFor="editContractNumber">Contract No</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="contractNumber" id="editContractNumber" placeholder="e.g. V-K00103-SC-01" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label nzFor="editContractStartDate">Contract Start Date</nz-form-label>
          <nz-form-control>
            <nz-date-picker
              formControlName="contractStartDate"
              id="editContractStartDate"
              nzFormat="yyyy-MM-dd"
            ></nz-date-picker>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label>Contract End (auto)</nz-form-label>
          <nz-form-control>
            <span>{{ editingUser?.contractEndDate ? (editingUser.contractEndDate | date:'yyyy-MM-dd') : '—' }}</span>
          </nz-form-control>
        </nz-form-item>
      </ng-container>
    </form>

    <div class="modal-actions">
      <button nz-button nzType="primary" (click)="updateUser()">Save</button>
      <button nz-button nzType="default" (click)="closeEditUserModal()">Cancel</button>
    </div>
  </ng-container>
</nz-modal>
